import { VSlideYTransition } from 'vuetify/lib/components/transitions';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"global-alerts"},[_c(VSlideYTransition,{attrs:{"group":""}},_vm._l((_vm.alerts),function(alert){return _c('alert',_vm._b({key:alert.id,on:{"close":_vm.remove}},'alert',alert,false))}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }